var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOvercoat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 57.965,
    viewBox: "0 0 56 57.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}.b{fill:#4c4c4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.085 4.488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.013,3.125,14.6,5.638,13.75,7.613l1.705,2.693L14.6,13S20.23,23.32,26.54,26.461",
    transform: "translate(-6.076 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.625,4.875,30.4,9.363a7.282,7.282,0,0,1,2.217,4.847l1.535,24.054H29.036",
    transform: "translate(-1.75 -2.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.085,14.375V46.687H20",
    transform: "translate(-3.799 1.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20,14.875c.341.718.767,1.436,1.194,2.154a50.181,50.181,0,0,0,3.07,4.4V46.559",
    transform: "translate(-3.799 1.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.875,3.125H25.4A42.382,42.382,0,0,1,21.138,20,42.381,42.381,0,0,1,16.875,3.125",
    transform: "translate(-4.938 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.945,3.125l3.411,2.513.853,1.975L26.5,10.305,27.355,13a51.968,51.968,0,0,1-6.48,9.065",
    transform: "translate(-3.48 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.241,38.264H8.125L9.66,14.21a7.282,7.282,0,0,1,2.217-4.847l4.775-4.488",
    transform: "translate(-8.125 -2.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.875,14.375V46.687H22.96",
    transform: "translate(-6.759 1.781)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 0.853,
    cy: 0.898,
    rx: 0.853,
    ry: 0.898,
    transform: "translate(13.643 25.131)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 0.853,
    cy: 0.898,
    rx: 0.853,
    ry: 0.898,
    transform: "translate(17.054 25.131)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 0.853,
    cy: 0.898,
    rx: 0.853,
    ry: 0.898,
    transform: "translate(13.643 30.517)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 0.853,
    cy: 0.898,
    rx: 0.853,
    ry: 0.898,
    transform: "translate(17.054 30.517)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 55.067,
    height: 57.965
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvercoat);
export default __webpack_public_path__ + "static/media/Overcoat.99cba3baa1632ef5e820d5aa19a6e7d8.svg";
export { ForwardRef as ReactComponent };